const THREE = (window.THREE = require('three'));

const config = {
  count: 80, //100, //200
  randomness: 8,
  wireZThreshold: -1000,
};

class AsteroidScene extends THREE.Scene {
  asteroids = [];

  constructor(occlusionEnabled) {
    super();

    this.update = this.update.bind(this);

    this.initAsteroids(occlusionEnabled);
  }

  initAsteroids = occlusionEnabled => {
    const asteroidMaterial = new THREE.MeshLambertMaterial({
      color: 0x343433,
      emissive: 0x121211,
      emissiveIntensity: 0.5,
      flatShading: true,
      vertexColors: THREE.FaceColors,
    });

    const asteroidWireMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      polygonOffset: true,
      polygonOffsetFactor: 1,
      polygonOffsetUnits: 1,
    });

    const wireMaterial = new THREE.LineBasicMaterial({
      color: 0xf1f1f1,
      linewidth: 1,
      lights: false,
    });

    let occlusionMaterial;
    if (occlusionEnabled) {
      occlusionMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 });
    }

    for (let i = 0; i < config.count; i++) {
      const asteroidGeometry = new THREE.OctahedronGeometry(20, 1);
      for (let i = 0; i < asteroidGeometry.vertices.length; i++) {
        const vertice = asteroidGeometry.vertices[i];
        vertice.x = (Math.random() - 0.5) * config.randomness + vertice.x;
        vertice.y = (Math.random() - 0.5) * config.randomness + vertice.y;
        vertice.z = (Math.random() - 0.5) * config.randomness + vertice.z;
      }
      asteroidGeometry.computeFlatVertexNormals();

      const speed = 0.075 + Math.random() * 0.025;
      const asteroid = new THREE.Mesh(asteroidGeometry, asteroidMaterial);
      asteroid.position.x = (Math.random() - 0.5) * 16000;
      asteroid.position.y = 1200 + (Math.random() - 0.5) * 500;
      asteroid.position.z = -12000 + (Math.random() - 0.5) * 10000;
      //asteroid.scale.multiplyScalar(0.2 + Math.random() * 0.8);
      if (Math.random() > 0.85) {
        asteroid.position.y -= 1000;
        asteroid.position.z += 10000;
        if (Math.random() > 0.15) {
          asteroid.position.y = -500 + Math.random() * 250;
          asteroid.position.z = -500 + Math.random() * 1000;
          asteroid.scale.multiplyScalar(1.5);
        }
      }
      asteroid.speed = speed * Math.abs((-18000 - asteroid.position.z) / 1000);
      this.asteroids.push(asteroid);
      this.add(asteroid);

      if (asteroid.position.z > config.wireZThreshold) {
        const wireAsteroid = new THREE.Mesh(
          asteroid.geometry,
          asteroidWireMaterial
        );

        const wireGeometry = new THREE.WireframeGeometry(asteroid.geometry);
        const wireMesh = new THREE.LineSegments(wireGeometry, wireMaterial);

        wireAsteroid.layers.set(100);
        wireMesh.layers.set(100);

        wireAsteroid.add(wireMesh);
        asteroid.add(wireAsteroid);
      }

      if (occlusionEnabled) {
        const occlusionBox = new THREE.Mesh(
          asteroidGeometry.clone(),
          occlusionMaterial
        );
        asteroid.add(occlusionBox);
        occlusionBox.layers.set(1);
      }
    }
  };

  update(deltaMultiplier) {
    const count = this.asteroids.length;
    for (let i = 0; i < count; i++) {
      const asteroid = this.asteroids[i];
      //asteroid.position.x += 1 * deltaMultiplier;
      asteroid.position.x += asteroid.speed * deltaMultiplier;
      asteroid.rotation.y += 0.01 * deltaMultiplier;
      asteroid.rotation.x += 0.01 * deltaMultiplier;
      if (asteroid.position.x > 8000) {
        asteroid.position.x -= 16000;
      }
    }
  }
}

export default AsteroidScene;



// WEBPACK FOOTER //
// ./src/modules/parallax/webgl/AsteroidScene.js